const initialState = {
    str: ''
}

const stcwIssuedRed = (state = initialState, action) => {
    switch(action.type){
        case 'STCW_ISSUED' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default stcwIssuedRed